module.exports = __webpack_public_path__ + "static/media/Faroe Islands.a2b17963.png";